export default function (){
    return (
        <div className="NoteFound">
            <p>404</p>
            Page ntago ibashije kuboneka
            </div>
    )
}